export class ComplianceTrend {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "points",
            "baseName": "points",
            "type": "Array<TrendPoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ComplianceTrend.attributeTypeMap;
    }
    constructor() {
    }
}
